// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"b1f9775a","505":"2c7d5b05","519":"4d52271d","642":"2f32b233","774":"adac7cbe","820":"6a6c8cb6","858":"6eaf4976"}[chunkId] + ".chunk.js";
};